import type { GoogleStoreLocatorApi, StoreLocatorProviderProps } from "../useStoreLocator";

export type UseGoogleMapsStoreLocator = (props: StoreLocatorProviderProps) => GoogleStoreLocatorApi;
